export const SourceType = {
    MASTER: 'master',
    LAYOUT: 'layout',
    SLIDE: 'slide',
};
